import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const ChapterBottomBar = ({ chapter, createImageParagraph }) => (
  <div className="ui segment right aligned grid">
    <div className="right floated ten wide column">
      <Link
        to={`/chapters/${chapter.id}/paragraphs/new`}
        className="ui right labeled icon button"
      >
        <i className="align left icon" />
        Ajouter un paragraphe
      </Link>
      <button
        className="ui right labeled icon button"
        onClick={createImageParagraph}
      >
        <i className="file image outline icon" />
        Ajouter une image
      </button>
    </div>
  </div>
);

ChapterBottomBar.propTypes = {
  chapter: PropTypes.object.isRequired,
  createImageParagraph: PropTypes.func.isRequired,
};

export default ChapterBottomBar;



// WEBPACK FOOTER //
// ./src/modules/memo/components/ChapterBottomBar.js